import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {WebsiteService} from '../../../../../websites/website.service';
import {WhiteLabel} from '../../../../../account/white-label/white-label';
import {WhiteLabelMapper} from '../../../../../account/white-label/white-label-mapper';
import {first} from 'rxjs/operators';
import {DbResponse} from '../../../../../shared/interceptors/db-response';
import {Notification} from '../../../../../shared/components/notifier/notification';
import {NotificationType} from '../../../../../shared/components/notifier/notification-type';
import {NotifierComponent} from '../../../../../shared/components/notifier/notifier.component';
import * as fromStore from '../../../../../store';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {switchMap} from "rxjs";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";
@Component({
    selector: 'db-wp-admin-white-label',
    templateUrl: './wp-admin-white-label.component.html',
    styleUrls: ['./wp-admin-white-label.component.scss'],
    standalone: false
})
export class WpAdminWhiteLabelComponent implements OnInit {
  protected readonly UserSubscriptionCategory = UserSubscriptionCategory;
  whiteLabelForm: FormGroup;
  defaultWhiteLabel: WhiteLabel;
  defaultLogo: boolean = true;
  selectedImage: any = null;
  loading: boolean = false;
  formSubmitted: boolean = false;
  cacheIcon: any = null;
  fileTypeError: boolean;
  currentSubscription: UserSubscription;
  private _destroyRef = inject(DestroyRef);

  constructor(
    private readonly _store: Store,
    private readonly _websiteService: WebsiteService
  ) {
    this.whiteLabelForm = new FormGroup({
      'companyName': new FormControl('', [Validators.required]),
    });
  }
  ngOnInit(): void {
    this.getWhiteLabelDefault();
    this._loadSubData();
  }

  private _loadSubData() {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(loaded => loaded),
        takeUntilDestroyed(this._destroyRef),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.currentSubscription = userSubscription;
      });
  }

  public useDefaultLogo(): void {
    this.defaultLogo = true;
    this.cacheIcon = null;
    this.selectedImage = null;
    (<HTMLInputElement>document.getElementById('uploadImage')).value = '';
  }

  public getWhiteLabelDefault(): void {
    this._websiteService.getWhiteLabel()
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        if (response.success) {
          this.defaultWhiteLabel = WhiteLabelMapper.map(response.data);
          if (this.defaultWhiteLabel.companyName) {
            this.whiteLabelForm.controls['companyName'].setValue(this.defaultWhiteLabel.companyName === '10Web' ? '' : this.defaultWhiteLabel.companyName);
          }
          if (this.defaultWhiteLabel.cacheIcon) {
            this.defaultLogo = false;
            this.selectedImage = this.defaultWhiteLabel.cacheIcon;
          }
        }
      });
  }

  public onFileChanged(event): void {
    this.fileTypeError = false;
    this.formSubmitted = false;
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (
        file.type &&
        (!file.type.startsWith('image/') || file.type === 'image/svg+xml')
      ) {
        NotifierComponent.notify(new Notification('File Type Is Not Allowed.', NotificationType.DANGER));
        return;
      }

      const formData = new FormData();
      formData.append('companyName', file);
      const reader = new FileReader();
      reader.onload = e => {
        this.selectedImage = reader.result;
      };
      this.defaultLogo = false;
      this.cacheIcon = file;
      reader.readAsDataURL(file);
    }
  }

  public saveWhiteLabel(): void {
    if (this.currentSubscription?.boosterCategory === UserSubscriptionCategory.AGENCY || this.currentSubscription?.isAgency || this.currentSubscription?.isApiResellerPlan) {
      this.formSubmitted = true;
      if ((this.whiteLabelForm.valid && this.selectedImage)
        || (!this.whiteLabelForm.valid && !this.selectedImage)
        || (this.whiteLabelForm.controls['companyName'].value === '10Web' && !this.selectedImage)) {
        this.loading = true;
        this._websiteService.storeWhiteLabel(this.whiteLabelForm.value, [], this.cacheIcon, this.defaultLogo, true)
          .pipe(first(response => !!response, null))
          .subscribe((response: DbResponse): void => {
            this.loading = false;
            if (response.success) {
              this._store.dispatch(new fromStore.LoadWebsites());
              NotifierComponent.notify(new Notification('Successfully saved', NotificationType.SUCCESS));
            } else {
              NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
            }
          });
      }
    }
  }
}
